/* tslint:disable */
import React, { Component } from 'react';
import { Common } from '../../core/common';
import { IHomePageBoxForumProps } from '../../models/components/homepage-box-forum';
import { IAppState } from '../../models/action/core';
import { connect } from 'react-redux';
import { IConversation } from '../../models/action/forum';
import { Log } from 'ng2-logger';
import { Redirect } from 'react-router-dom';
import Translator from '../../core/i18n';
import Loading from '../loading/loading';
import { IProfileProps } from '../../models/pages/profile';
import * as Actions from '../../store/actions/profile';
import Moment from 'moment';
import ContentLoader from 'react-content-loader';
import { IPreference } from '../../models/action/profile';
import ShowAllButton from '../show-all-button/main';

const T = Translator.create();
let _common: Common;
const _logger = Log.create('Home Box Forum');
export class CForum extends Component<IHomePageBoxForumProps & IProfileProps> {
    state = {
        redirect: false,
        redirectUrl: '/',
        boxItems: ['0', '1', '2', '3', '4', '5'],
        boxItemsVisual: [false, false, false, false, false, false],
        boxCount: 0
    };

    constructor(props: any) {
        super(props);
        _common = new Common();
        if (T.i18next.language === 'tr') {
            Moment.locale('tr');
        }
        if (T.i18next.language === 'en') {
            Moment.locale('en');
        }
    }

    public handleChange = () => {
        if (this.props.userPreferences) {
            this.props.userPreferences.forEach(preference => {
                if (preference.name === 'home.index.boxallowed') {
                    if (preference.value) {
                        this.state.boxItems = preference.value.split(',');
                        let index = this.state.boxItems.indexOf('4')
                        if (index !== -1)
                            this.state.boxItems.splice(index, 1)
                        this.state.boxItems.forEach(item => {
                            this.state.boxItemsVisual[parseInt(item, 10)] = true;
                        });
                    }
                }
            })
            let preferenceData
            const teacherPreferencesName = this.props.userPreferences[1].name
            const studentPreferencesName = this.props.userPreferences[0].name
            const preferencesValue = this.state.boxItems.toString()

            {
                teacherPreferencesName === 'home.index.boxallowed' ?
                (preferenceData = {
                    preferences:
                        [{ name: teacherPreferencesName, value: preferencesValue }]
                })
                : (preferenceData = {
                    preferences:
                        [{ name: studentPreferencesName, value: preferencesValue }]
                })
            }
            this.props.dispatch(Actions.addOrUpdatePreferencesAction(preferenceData));
        }
    }

    onClickNavigateUrl = (forumThreadId?: string, tabIndex?: number) => (event: any) => {
        let url = 'u/Forum/Index';
        if (forumThreadId && tabIndex) {
            url = url + '?forumThreadId=' + forumThreadId + '&tabIndex=' + tabIndex;
        }
        this.setState({ redirect: true, redirectUrl: url });
    }

    componentDidMount () {
        if (this.props.userPreferences!.length > 0) {
            if (this.props.userPreferences!.find(pref => pref.name === 'home.index.boxcount')) {
                this.setState({
                    boxCount: (this.props.userPreferences!.find(pref => pref.name === 'home.index.boxcount') as IPreference).value
                });
            }
        }
    }

    renderLoading = () => {
        const loadingSpaces = 70;
        const loadingSizes = this.state.boxCount == 2 ? '0 0 540 300' : '0 0 350 300';
        const loadingWidth = this.state.boxCount == 2 ? 540 : 350;

        return(
            <Loading spinnerId={'getHomeBoxForums'}>
                <div style={{ backgroundColor: '#fbfaf6' }}>
                    <ContentLoader
                        speed={2}
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                        viewBox={loadingSizes}
                        style={{ width: '100%' }}
                    >
                        <rect x="16" y="24" rx="3" ry="3" width="315" height="10" />
                        <rect x="16" y="44" rx="3" ry="3" width="120" height="8" />
                        <rect x="145" y="45" rx="3" ry="3" width="135" height="7" />
                        <rect x="16" y="60" rx="3" ry="3" width="265" height="7" />
                        <rect x="16" y="74" rx="3" ry="3" width="70" height="7" />
                        <rect x={loadingWidth - (20 + 40)} y="44" rx="17" ry="17" width="40" height="30" />

                        <rect x="16" y={24 + loadingSpaces} rx="3" ry="3" width="315" height="10" />
                        <rect x="16" y={44 + loadingSpaces} rx="3" ry="3" width="120" height="8" />
                        <rect x="145" y={45 + loadingSpaces} rx="3" ry="3" width="135" height="7" />
                        <rect x="16" y={60 + loadingSpaces} rx="3" ry="3" width="265" height="7" />
                        <rect x="16" y={74 + loadingSpaces} rx="3" ry="3" width="70" height="7" />
                        <rect x={loadingWidth - (20 + 40)} y={44 + loadingSpaces} rx="17" ry="17" width="40" height="30" />

                        <rect x="16" y={24 + loadingSpaces * 2} rx="3" ry="3" width="315" height="10" />
                        <rect x="16" y={44 + loadingSpaces * 2} rx="3" ry="3" width="120" height="8" />
                        <rect x="145" y={45 + loadingSpaces * 2} rx="3" ry="3" width="135" height="7" />
                        <rect x="16" y={60 + loadingSpaces * 2} rx="3" ry="3" width="265" height="7" />
                        <rect x="16" y={74 + loadingSpaces * 2} rx="3" ry="3" width="70" height="7" />
                        <rect x={loadingWidth - (20 + 40)} y={44 + loadingSpaces * 2} rx="17" ry="17" width="40" height="30" />

                        <rect x="16" y={24 + loadingSpaces * 3} rx="3" ry="3" width="315" height="10" />
                        <rect x="16" y={44 + loadingSpaces * 3} rx="3" ry="3" width="120" height="8" />
                        <rect x="145" y={45 + loadingSpaces * 3} rx="3" ry="3" width="135" height="7" />
                        <rect x="16" y={60 + loadingSpaces * 3} rx="3" ry="3" width="265" height="7" />
                        <rect x="16" y={74 + loadingSpaces * 3} rx="3" ry="3" width="70" height="7" />
                        <rect x={loadingWidth - (20 + 40)} y={44 + loadingSpaces * 3} rx="17" ry="17" width="40" height="30" />
                    </ContentLoader>
                </div>
            </Loading>
        )
    }

    public render() {
        const loadingSpaces = 90;
        const loadingSizes = '0 0 315 800';
        const loadingWidth = 315;
        if (this.state.redirect) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/' + this.state.redirectUrl} />;
        }
        return (
            <div className="white-box student-discussions shadow">
                <div className="d-flex justify-content-between white-box-header">
                    <div>
                        <span className='lms-header-medium' tabIndex={0}>{T.t('r_home_index_box_forum')}<span className='badge badge-pill badge-light py-1 px-2' style={{marginInlineStart: "0.5rem"}}  tabIndex={0}>{this.props.myGroup ? this.props.myGroup.length : ''}</span></span>
                    </div>
                    <div className="align-self-center">
                        <i
                            aria-hidden= "true"
                            className="material-icons mr-2 align-middle"
                            onClick={this.handleChange}
                            style={{ cursor: 'pointer' }}
                        >
                            visibility
                        </i>
                        <ShowAllButton redirectUrl='/u/Forum/Index'/>
                    </div>
                </div>
                <Loading spinnerId={'getHomeBoxForums'}>
                    <div style={{ backgroundColor: '#fbfaf6' }}>
                        <ContentLoader
                            speed={2}
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"
                            viewBox={loadingSizes}
                            style={{ width: '100%' }}
                        >
                            <rect x="16" y="24" rx="3" ry="3" width="315" height="10" />
                            <rect x="16" y="44" rx="3" ry="3" width="120" height="8" />
                            <rect x="145" y="45" rx="3" ry="3" width="135" height="7" />
                            <rect x="16" y="60" rx="3" ry="3" width="265" height="7" />
                            <rect x="16" y="74" rx="3" ry="3" width="70" height="7" />
                            <rect x={loadingWidth - (20 + 40)} y="44" rx="17" ry="17" width="40" height="30" />

                            <rect x="16" y={24 + loadingSpaces} rx="3" ry="3" width="315" height="10" />
                            <rect x="16" y={44 + loadingSpaces} rx="3" ry="3" width="120" height="8" />
                            <rect x="145" y={45 + loadingSpaces} rx="3" ry="3" width="135" height="7" />
                            <rect x="16" y={60 + loadingSpaces} rx="3" ry="3" width="265" height="7" />
                            <rect x="16" y={74 + loadingSpaces} rx="3" ry="3" width="70" height="7" />
                            <rect x={loadingWidth - (20 + 40)} y={44 + loadingSpaces} rx="17" ry="17" width="40" height="30" />

                            <rect x="16" y={24 + loadingSpaces * 2} rx="3" ry="3" width="315" height="10" />
                            <rect x="16" y={44 + loadingSpaces * 2} rx="3" ry="3" width="120" height="8" />
                            <rect x="145" y={45 + loadingSpaces * 2} rx="3" ry="3" width="135" height="7" />
                            <rect x="16" y={60 + loadingSpaces * 2} rx="3" ry="3" width="265" height="7" />
                            <rect x="16" y={74 + loadingSpaces * 2} rx="3" ry="3" width="70" height="7" />
                            <rect x={loadingWidth - (20 + 40)} y={44 + loadingSpaces * 2} rx="17" ry="17" width="40" height="30" />

                            <rect x="16" y={24 + loadingSpaces * 3} rx="3" ry="3" width="315" height="10" />
                            <rect x="16" y={44 + loadingSpaces * 3} rx="3" ry="3" width="120" height="8" />
                            <rect x="145" y={45 + loadingSpaces * 3} rx="3" ry="3" width="135" height="7" />
                            <rect x="16" y={60 + loadingSpaces * 3} rx="3" ry="3" width="265" height="7" />
                            <rect x="16" y={74 + loadingSpaces * 3} rx="3" ry="3" width="70" height="7" />
                            <rect x={loadingWidth - (20 + 40)} y={44 + loadingSpaces * 3} rx="17" ry="17" width="40" height="30" />
                        </ContentLoader>
                    </div>
                </Loading>
                <ul id="getHomeBoxForums_Content" className="white-box-body">
                    {
                         this.props.myGroup&&this.props.myGroup.length>0 ?
                            this.props.myGroup.map((group: IConversation, key) => {
                                return (
                                    <li className="media mb-3" key={key}>
                                        <div className="media-body">
                                            <div className="d-inline-block w-90">
                                                <h5 onClick={this.onClickNavigateUrl(group.forumThreadId, 1)}  className={ (!_common.isArabic(group.subject, document.body.getAttribute('dir')) ? 'arabic-text-direction mt-0 homebox-clickable-item' : 'mt-0 homebox-clickable-item')}  tabIndex={0}
                                                 onKeyDown={event => {
                                                    if (event.key === 'Enter') {
                                                        this.onClickNavigateUrl(group.forumThreadId, 1)
                                                    }
                                                }}>{group.subject}</h5>
                                                <span onClick={this.onClickNavigateUrl(group.forumThreadId, 1)}  tabIndex={0} style={{ cursor: 'pointer', float: (document.body.getAttribute('dir') == 'rtl' && !_common.isArabic(group.lastMessage)) ? 'left': 'unset' , direction: (document.body.getAttribute('dir') == 'rtl'  && !_common.isArabic(group.lastMessage)) ? 'ltr': 'rtl'}}><b>{group.firstName} {group.lastName}: </b></span>
                                                <span onClick={this.onClickNavigateUrl(group.forumThreadId, 1)} style={{cursor: 'pointer', lineHeight: 1.145, float: (document.body.getAttribute('dir') == 'rtl' && !_common.isArabic(group.lastMessage)) ? 'left': 'unset' , direction: (document.body.getAttribute('dir') == 'rtl'  && !_common.isArabic(group.lastMessage)) ? 'ltr': 'rtl'}} tabIndex={0} dangerouslySetInnerHTML={{ __html: (group.lastMessage) ? (group.lastMessage.length > 180) ? group.lastMessage.slice(0, 180).replace(/<\/?[^>]+(>|$)/g, '') + ' ...' : group.lastMessage.replace(/<\/?[^>]+(>|$)/g, '') : '' }} />
                                                <i tabIndex={0}>{group.lastMessageDate ? Moment(group.lastMessageDate).fromNow() : ''}</i>
                                            </div>
                                            <div>
                                            <span className="message-counter" tabIndex={0}>{group.totalMessageCount}</span>
                                            </div>
                                        </div>
                                    </li>);
                            }) : (
                                <p tabIndex={0}>{T.t('r_home_box_forum_not_found')}</p>
                            )
                    }
                </ul>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IHomePageBoxForumProps): IHomePageBoxForumProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: IHomePageBoxForumProps = Object.assign({}, ownProps, {
        myGroup: state.forum.homePageConversation,
        userPreferences: state.profile.userPreferences.preferences
    });

    return newProps;
};

const Forums = connect(
    mapStateToProps
)(CForum);

export default Forums;
